import { RootState, useAppSelector } from './app'

/**
 * Creates a selector hook scoped to a specific sub-slice.
 */
export const makeSubSelector =
  <Slice>(pickSlice: (root: RootState) => Slice) =>
  <T>(selector: (slice: Slice) => T) =>
    useAppSelector((root) => selector(pickSlice(root)))
